<template>
  <div class="edit-table">
    <vxe-table ref="fineTable" :data="tableData" max-height="500px">
      <vxe-table-column
        min-width="100"
        field="productCode"
        title="产品编码"
      ></vxe-table-column>
      <vxe-table-column
        min-width="100"
        field="productName"
        title="产品名称"
      ></vxe-table-column>
      <vxe-table-column min-width="120" field="productType" title="产品类型">
        <template #default="{ row }">
          <span v-if="row.productType === 'GIVE'">赠送产品</span>
          <span v-if="row.productType === 'THROW'">投放产品</span>
          <span v-if="row.productType === 'ENTRY'">进场产品</span>
          <span v-if="row.productType === 'CONFER'">会议用酒</span>
          <span v-if="row.productType === 'PROCUREMENT'">采购商品</span>
          <span v-if="row.productType === 'BANQUET'">宴席用酒</span>
          <span v-if="row.productType === 'MEETING_WINE'">会议用酒</span>
          <span v-if="row.productType === 'GIVING_PRODUCT'">赠送产品</span>
          <span v-if="row.productType === 'GIFT'">礼品</span>
        </template>
      </vxe-table-column>
      <vxe-table-column
        min-width="100"
        field="productNum"
        title="产品数量"
      ></vxe-table-column>
      <vxe-table-column
        min-width="100"
        field="productPrice"
        title="产品价格"
      ></vxe-table-column>
    </vxe-table>
  </div>
</template>

<script>
export default {
  props: {
    value: Array,
  },
  watch: {
    value() {
      this.tableData = this.value;
    },
  },
  data() {
    return {
      tableData: [],
    };
  },

  methods: {},
};
</script>
